import React, { useState, useEffect } from "react";
import { BSBtn, BSModal } from "traec-react/utils/bootstrap";
import ReportRowErrorBoundary from "./error";
import { DocumentTitleTooltip, CurrentObject, DocumentNoReportCheckbox } from "./reportDocumentRow";
import { fetcher } from "storybook-dashboard/utils/fetching";
import Papa from "papaparse";
import { alertSuccess } from "traec-react/utils/sweetalert";
import { DataTable } from "./dataTable";
import { Hider } from "storybook-dashboard/utils";
import Im from "immutable";
import { Tooltip } from "react-tippy";
import Swal from "sweetalert2";

export const fetchS3Object = ({ trackerId, commitId, docId, currentDocObject, responseHandler, failureHandler }) => {
  let docObjectId = currentDocObject.get("uid");
  fetcher(`/api/tracker/${trackerId}/commit/${commitId}/document/${docId}/object/${docObjectId}/?url=true`, "GET")
    .then(({ payload }) => {
      let signed_url = payload.get("signed_url");
      if (signed_url) {
        fetch(signed_url, { cache: "no-cache" }).then(responseHandler);
      }
    })
    .catch((err) => {
      failureHandler ? failureHandler(err) : null;
    });
};

function LoadDataButton(props) {
  let { title, hide } = props;
  if (hide) {
    return null;
  }
  return (
    <button
      className="btn btn-primary btn-sm pl-1 pr-1 m-0 p-9 float-right"
      onClick={(e) => {
        e.preventDefault();
        fetchS3Object(props);
      }}
    >
      {title}
    </button>
  );
}

const textToDataArray = (text) => {
  let results = Papa.parse(text, { header: true });
  return results.data;
};

export function LoadOrEditDataButton(props) {
  let { data, setData, doc, modalId, currentDocObject, readOnly, hide } = props;

  let docId = doc.get("uid");
  let current_url = currentDocObject ? currentDocObject.get("url") : null;
  let hasData = Im.isList(data) ? data.size > 0 : false;

  useEffect(() => {
    if (!hasData && !current_url) {
      setData(Im.List([Im.Map()]));
    }
  });

  if (hide) return null;

  if (!hasData && current_url) {
    return (
      <LoadDataButton
        {...props}
        title={readOnly ? "View data" : "Edit data"}
        docId={docId}
        currentDocObject={currentDocObject}
        responseHandler={(response) =>
          response
            .text()
            .then((_text) => {
              setData(Im.fromJS(textToDataArray(_text)));
              $(`#${modalId}`).modal("show");
            })
            .catch((e) => {
              console.warn("ERROR LOADING DATA");
            })
        }
        failureHandler={(error) => {
          alertSuccess({
            title: "Error loading data",
            text: "There was an issue loading data for this form.  You will be presented with a new blank form to complete.  If you have issues or need to retrieve this data then please contact support.",
          });
          $(`#${modalId}`).modal("show");
        }}
      />
    );
  }

  let action = readOnly ? "View" : hasData ? "Edit" : "Add new";
  return (
    <BSBtn
      text={`${action} data`}
      onClick={(e) => $(`#${modalId}`).modal("show")}
      extra_className="pl-1 pr-1 m-0 p-0 float-right"
      noFloatRight={true}
    />
  );
}

export function ReportDocumentFormButton(props) {
  let { doc, rowColor, indentLevel, readOnly, docStatus, summaryReport } = props;
  let [data, setData] = useState(Im.List());
  let [dirty, setDirty] = useState(false);

  if (!doc) return null;

  let formDetails = doc.getIn(["meta_json", "input_details"]) || Im.Map();
  let formTemplate = doc.getIn(["meta_json", "input_details", "file_template"]) || Im.Map();
  let formFields = formDetails.get("fields");

  let modalId = `${doc.get("uid")}-form`;
  let modalTitle = formDetails.get("name");

  let noReport = docStatus?.getIn(["status", "name"]) == "Not for Submission";

  let assignments = doc.getIn(["meta_json", "assignments"]);
  let hideNA = doc.getIn(["meta_json", "hideNA"]) == true;

  return (
    <ReportRowErrorBoundary>
      <tr style={{ backgroundColor: rowColor }}>
        <td className="border-0">
          <DocumentTitleTooltip doc={doc} indentLevel={indentLevel} />
        </td>

        <td colSpan={summaryReport ? 2 : 3} className={`border-0`}>
          <CurrentObject {...props} docId={doc.get("uid")} hide={noReport} />

          {summaryReport ? (
            <Tooltip html={"Go back to the report to see this data"}>
              <button className="btn btn-sm btn-secondary ml-2" style={{ cursor: "pointer" }} disabled>
                View data
              </button>
            </Tooltip>
          ) : (
            <>
              <LoadOrEditDataButton {...props} data={data} setData={setData} modalId={modalId} hide={noReport} />

              <BSModal
                id={modalId}
                title={modalTitle}
                fullWidth={true}
                body={
                  <DataTable
                    {...props}
                    fields={formFields}
                    formName={modalTitle}
                    data={data}
                    setData={setData}
                    dirty={dirty}
                    setDirty={setDirty}
                    formTemplate={formTemplate}
                    assignments={assignments}
                  />
                }
                onClose={() => {
                  if (dirty) {
                    Swal.fire({
                      title: "Unsaved data",
                      text: "You have not saved all your data, do you still wish to close this window?",
                      type: "warning",
                      showCancelButton: true,
                      cancelButtonColor: "#3085d6",
                      confirmButtonColor: "#d33",
                      confirmButtonText: "Proceed",
                    }).then((result) => {
                      if (result.value) $(`#${modalId}`).modal("hide");
                    });
                  } else {
                    $(`#${modalId}`).modal("hide");
                  }
                }}
              />
            </>
          )}
        </td>

        <td className="text-center border-0">
          <Hider hide={hideNA}>
            <DocumentNoReportCheckbox {...props} disableInputs={readOnly} />
          </Hider>
        </td>
        <td className="border-0">{/* Admin dropdown here */}</td>
      </tr>
    </ReportRowErrorBoundary>
  );
}
